export enum ReportEditionDetailsUserActionTypes {
    openReportEdition = '[Report Edition/User] Open Report Edition',
    openKpiSetDetails = '[Report Edition/User] Open KPI Set Details',
    reloadKpiSetDetails = '[Report Edition/User] Reload KPI Set Details',
    reloadReportEdition = '[Report Edition/User] Reload Report Edition',
    regenerateEdition = '[Report Edition/User] Regenerate Report Edition',
    toggleSelectedKpi = '[Report Edition/User] Toggle selected kpi notification',
}

export enum ReportEditionDetailsApiActionTypes {
    getReportEditionSuccess = '[Report Edition/Api] Get Report Edition Success',
    getReportEditionFailure = '[Report Edition/Api] Get Report Edition Failure',
    putRegenerateEditionFailure = '[Report Edition/Api] Put Regenerate Edition Failure',
    putRegenerateEditionSuccess = '[Report Edition/Api] Put Regenerate Edition Success',
    getFilterOperationTime = '[Report/Api] Get Filter Operation Time',
    getFilterOperationTimeSuccess = '[Report/Api] Get Filter Operation Time Success',
    getFilterOperationTimeFailure = '[Report/Api] Get Filter Operation Time Failure',
}

export interface ReportEditionStartRegenerate {
    toDate: string;
    fromDate: string;
    id: string;
}
